export const enumMapper = (enumObj: { [key: string]: string | number }) => {
  return Object.values(enumObj)
    .filter((v) => typeof v === 'string')
    .map((v) => {
      return {
        value: enumObj[v as keyof typeof enumObj].toString(),
        label: v as string,
      };
    });
};

export const enumMapperValueAsNumber = (enumObj: {
  [key: string]: string | number;
}) => {
  return Object.values(enumObj)
    .filter((v) => typeof v === 'string')
    .map((v) => {
      return {
        value: enumObj[v as keyof typeof enumObj],
        label: v as string,
      };
    });
};
